/**
 * 根据得分获得区间对应的字体颜色
 * @param scoreValue 绩效评估得分
 * @returns color 字体颜色
 */
export function getScoreColor(scoreValue: number) {
  const scoreColor: Record<string, string> = {
    25: "#ef4444",
    50: "#fb923c",
    75: "#3b82f6",
    100: "#16a34a",
  };

  let targetColor = "";
  if (scoreValue === null || scoreValue === undefined) return targetColor;

  for (const score of Object.keys(scoreColor)) {
    if (scoreValue >= Number(score)) {
      targetColor = scoreColor[score];
    }
  }

  return targetColor;
}

/**
 * 根据得分获得区间绩效等级对应的字体颜色
 * @param scoreValue 绩效总得分
 * @returns color 字体颜色
 */
export function getLevelColor(scoreValue: number) {
  const scoreColor: Record<string, string> = {
    60: "#ef4444",
    85: "#fb923c",
    100: "#16a34a",
  };

  let targetColor = "";
  if (scoreValue === null || scoreValue === undefined) return targetColor;

  for (const score of Object.keys(scoreColor)) {
    if (scoreValue <= Number(score)) {
      targetColor = scoreColor[score];
      break;
    }
  }

  return targetColor;
}
